import { extractMembers, extractPersonFromJsonLd } from '@atlaskit/link-extractors';
export const extractPersonsUpdatedBy = jsonLd => {
  if (jsonLd['@type'] === 'atlassian:Project') {
    const members = extractMembers(jsonLd);
    if (members && members.length !== 0) {
      return members;
    }
  }
  const updatedBy = jsonLd['atlassian:updatedBy'];
  if (updatedBy) {
    const extractedPersons = extractPersonFromJsonLd(updatedBy);
    return extractedPersons ? [extractedPersons] : undefined;
  }
};